import { render, staticRenderFns } from "./SMSPendingView.vue?vue&type=template&id=20082ac4&scoped=true"
import script from "./SMSPendingView.vue?vue&type=script&lang=js"
export * from "./SMSPendingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20082ac4",
  null
  
)

export default component.exports